export default __webpack_public_path__ + "static/media/washupStep5.22735f91.png";